import { useAuthentication } from 'common/contexts/Authentication';
import React, { useState, useEffect } from 'react';
import { Navbar } from 'react-bootstrap';
import { FiMenu } from 'react-icons/fi';
import { useTranslation, withTranslation } from 'react-i18next';

function Header({
  children,
  toggleMenu,
}) {

  const { t, i18n } = useTranslation('header');
  const authentication = useAuthentication();


  return <>
    <header id="navbar" className="bg-etusia-green">
      <Navbar>
        <div className="navbar-items row">
          {
            authentication.isAuthenticated() ?
              <>
                <span className="navbar-title col-auto text-white" style={{flex:1}}>
                  <span className='mobile-menu-toggle' style={{marginRight: '2rem'}} onClick={() => toggleMenu(true)}>
                    <FiMenu />
                  </span>
                </span>
                <span className="col-auto text-white navbar-title" style={{flex:1, textAlign:'center'}} >
                  { authentication.getMerchantName() }
                </span>
              </>
              : <div><img className='logo' src='./images/etuisa_logo.png' alt='logo' /></div>
          }

          <Navbar.Collapse id="navItems" style={{flex:1}} className="col-3 pe-0">
            {children}
          </Navbar.Collapse>
        </div>
      </Navbar>
    </header>


  </>;
}

export default withTranslation('header')(Header);